import clsx from 'clsx'
import type { ReactNode } from 'react'

export interface SidePanelTab {
  id: string
  label: string
  count?: number
}

export interface SidePanelProps {
  tabs: SidePanelTab[]
  active: string
  onTab: (id: string) => void
  /** Optional control row under the tabs (e.g. full-page detail toggle). */
  headerActions?: ReactNode
  children: ReactNode
}

export function SidePanel({ tabs, active, onTab, headerActions, children }: SidePanelProps) {
  return (
    <section className="flex min-h-0 flex-col rounded-[14px] border border-[rgba(15,23,42,0.07)] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
      <div className="p-2 pb-0">
        <div
          className="flex flex-wrap gap-1 rounded-[10px] bg-[#EEF2F7] p-1"
          role="tablist"
        >
          {tabs.map((tab) => {
            const isActive = tab.id === active
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => onTab(tab.id)}
                className={clsx(
                  'flex h-8 shrink-0 items-center justify-center gap-1.5 rounded-[8px] px-2.5 text-[11px] transition-colors',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]',
                  isActive
                    ? 'bg-white font-semibold text-[#0F172A] shadow-[0_1px_3px_rgba(15,23,42,0.10)]'
                    : 'font-medium text-[#64748B] hover:text-[#0F172A]',
                )}
              >
                {tab.label}
                {tab.count != null ? (
                  <span className="font-mono text-[11px] tabular-nums text-[#94A3B8]">{tab.count}</span>
                ) : null}
              </button>
            )
          })}
        </div>
        {headerActions ? <div className="mt-2">{headerActions}</div> : null}
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-2.5 p-3">{children}</div>
    </section>
  )
}
